const ensure2digits = (n: number): string => {
    return n >= 10 ?
    `${n}` :
    `0${n}`;
};

export default ensure2digits;
